export default (state = [], action) => {
    switch (action.type) {
        case 'INITIALIZE_CASE_DETAILS':
            return action.cases.map((c) => ({ ...c, caseItems: [] }));
        default:
            return state;
    }
};
